import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AAvoidTrafficEvents, GoogleMapOptionsEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapStoreService } from '../../services/google-map-store/google-map-store.service';
import { GoogleMapType } from '../../enums/google-map-enum';
import { TrafficAlertMarkerService } from '../../services/marker-cluster/traffic-alert-marker.service';
import { CarParkMarkerService } from '../../services/marker-cluster/car-park-marker.service';
import { RouteDataStoreService } from 'src/app/modules/aa-core/services/data-store/data-store.service';
import { GoogleMapOptionsModel } from '../../models/google-map-model';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'aa-traffic-alert-car-park',
    templateUrl: './traffic-alert-car-park.component.html',
    styleUrls: ['./traffic-alert-car-park.component.scss'],
    standalone: false
})
export class TrafficAlertCarParkComponent implements OnInit, OnDestroy {

  public CarParkModel: boolean;
  public TrafficAlertModel: boolean;
  public googleMapOptions: GoogleMapOptionsModel;
  public isDesktop = true;
  private subscription: Subscription;
  public hideDropDownMenu = false;

  constructor(private eventsService: EventsService,
    private trafficAlertMarkerService: TrafficAlertMarkerService,
    private carParkMarkerService: CarParkMarkerService,
    private googleMapStore: GoogleMapStoreService,
    private routePlanDataStore: RouteDataStoreService,
    private appUtilityService: AppUtilityService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.setupMobileUI();

    this.googleMapOptions = this.routePlanDataStore.routeDataModel.googleMapOptions;
    this.eventsService.on(AAvoidTrafficEvents.UPDATE_TRAFFIC, this.onUpdateTrafficAlert);

    this.CarParkModel = this.googleMapOptions.CarPark;
    this.TrafficAlertModel = this.googleMapOptions.TrafficAlert || this.googleMapOptions.CurrentTraffic;
  }

  ngOnDestroy() {
    this.eventsService.remove(AAvoidTrafficEvents.UPDATE_TRAFFIC, this.onUpdateTrafficAlert);
    this.subscription.unsubscribe();
  }

  private onUpdateTrafficAlert = (event: any) => {
    this.googleMapOptions.CurrentTraffic = event;
    this.TrafficAlertModel = this.googleMapOptions.TrafficAlert || this.googleMapOptions.CurrentTraffic;
    this.onShowHideTrafficAlerts(this.TrafficAlertModel);
    this.eventsService.dispatch(GoogleMapOptionsEvents.TRAFFIC_ALERT_CHANGED, this.options);
    this.cdr.detectChanges();
  }

  onShowHideTrafficAlerts(value: boolean): void {
    this.googleMapOptions.TrafficAlert = value;
    this.eventsService.dispatch(GoogleMapOptionsEvents.TRAFFIC_ALERT_CHANGED, this.options);
  }

  onShowHideCarPark(value: boolean): void {
    this.googleMapOptions.CarPark = value;
    this.eventsService.dispatch(GoogleMapOptionsEvents.CARPARK_CHANGED, this.options);
  }

  get options(): {googleMap: IGoogleMap, options: GoogleMapOptionsModel} {
    const googleMap = this.googleMapStore.getGoogleMap(GoogleMapType.ROUTE_PLANNER);
    return {googleMap: googleMap, options: this.googleMapOptions};
  }

  onCloseDropdown(): void {
    this.hideDropDownMenu = !this.hideDropDownMenu;
  }

  private setupMobileUI(): void {
    this.hideDropDownMenu = this.appUtilityService.isStrictlyMobile;

    this.subscription = this.appUtilityService.windowResizeEmitter$.subscribe((data: any) => {
      this.isDesktop = this.appUtilityService.isDeviceCheck();
      this.hideDropDownMenu = (this.isDesktop === false);
    });
  }

}
